import { useEffect, useMemo } from 'react';
import './IndirPage.css';
import logo from './assets/mmjlogo.png';
import {
  detectAppPlatform,
  getAppStoreLabelForPlatform,
  getAppStoreUrlForPlatform,
} from './appDownload';

/** Kısa gecikme: yükleme ekranı okunabilsin; sonra mağazaya tam sayfa yönlendirme. */
const REDIRECT_DELAY_MS = 550;

export default function IndirPage() {
  const platform = useMemo(() => detectAppPlatform(), []);
  const storeLabel = getAppStoreLabelForPlatform(platform);
  const storeUrl = getAppStoreUrlForPlatform(platform);

  useEffect(() => {
    const id = window.setTimeout(() => {
      window.location.replace(storeUrl);
    }, REDIRECT_DELAY_MS);
    return () => window.clearTimeout(id);
  }, [storeUrl]);

  return (
    <div className="indir-load" role="status" aria-live="polite" aria-busy="true" lang="tr">
      <div className="indir-load-inner">
        <img src={logo} alt="" className="indir-load-logo" decoding="async" />
        <div className="indir-load-spinner" aria-hidden />
        <p className="indir-load-msg">{storeLabel}’a yönlendiriliyorsunuz…</p>
      </div>
    </div>
  );
}
